module.exports = __webpack_public_path__ + "img/Profil_SB-bis-2008.379d59aa.jpg";